// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1Vg3s","emails":"CreateEditClinics_emails__1-Txq","emailTagLabel":"CreateEditClinics_emailTagLabel__2WCX1"};